import React from "react";
// import Wrp from '../../hoc/Wrp/Wrp';
import { isSet } from '../../Utils/CommonFunctions';
import {getSelectedValueBasedOnField} from '../../Utils/CommonFunctions';

  export const formInputFieldsKeyRef =(key)=>{
      
    let fieldArray = {
      ['Number']:'Number',
      ['Email']:'Email',
      ['LongNumber']:'LongNumber',
      ['Date']:'DatePick',
      ['TextInput']:'TextInput',
      ['Phone']:'Phone',
      ["PickList"]:'PickList',
      ['Currency']:'Currency',
      ['DateTime']:'DateTime',
      ['Decimal']:'Decimal',
      ['Percentage']:'Percentage',
      ['TextArea']:'TextArea',
      ['CheckBoxes']:'Checkbox'
    }
    return (fieldArray[key]===undefined)?'TextInput':fieldArray[key];
  }

  export const formInputFields =(key)=>{
    return  [
      'Number',
      'Email',
      'LongNumber',
      'Date',
      'TextInput',
      'Phone',
      'Currency',
      'DateTime',
      'Decimal',
      'Percentage',
      'TextArea',
      'CheckBoxes'
    ]
  }


  export const billingInfoKeys =()=>{
   return [
     { 
        name:'Company Name',
        obj:'companyName'
     },{ 
        name:'Address 1',
        obj:'address1'
     },{ 
        name:'Address 2',
        obj:'address2'
     },{ 
        name:'City',
        obj:'city'
     },{ 
        name:'State',
        key:'state'
      },{ 
        name:'Country',
        obj:'country'
      },{ 
        name:'Zip Code',
        obj:'zipCode'
      }
    ]
  }


  export const getShippingAddressDetails = (fieldGroups,sectionName)=>{
    let billingInfo = {};
    // BILLING_KEYS
    fieldGroups.map((section)=>{
      if(section.title===sectionName){
        section.data.map((field)=>{
          const fieldName = (field.label.blocks[0].text).toLowerCase();
          const key = billingInfoKeys().findIndex(elmt=> fieldName.indexOf(elmt.name.toLowerCase())!==-1 );
          if(key>-1){
            const selectedValue = getSelectedValueBasedOnField(field);
            billingInfo = {
              ...billingInfo,
              [billingInfoKeys()[key]['obj']]:(selectedValue!==undefined)?selectedValue:' '
            }
          }
        })
      }
    })
    return billingInfo;
  } 

  export const updateInputAndOutputAtt = (updatedPayload,attr,dataIndex,obj,value)=>{
        const {id,headerName} = obj;
        const colId = id;
        updatedPayload[dataIndex][attr][colId] = {
          ...updatedPayload[dataIndex][attr][colId],
          [headerName]:value
        }
        return updatedPayload;
  }


  export const getVariablesFromProps = (variablesAndSheetList,isTax=false,isTaxType='INPUT') => {
      let varList = [];
      let globalVarList = [];
      if(variablesAndSheetList.rateSheetsList[0] !== null){
      isSet(variablesAndSheetList.rateSheetsList,[]).map((arr) => {
          isSet(arr.output_variables,[]).map((arr) => {
            varList.push(arr);
          })
      })
    }
      isSet(variablesAndSheetList.constantsList,[]).map((arr) => {
        varList.push(arr);
        globalVarList.push(arr);
      })
      isSet(variablesAndSheetList.variablesList,[]).map((arr) => {
        varList.push(arr);
        globalVarList.push(arr);
      });
      if(isTax===true){
        varList = [];
        isSet(variablesAndSheetList.taxVariablesList,[]).map((arr,ind) => {
          if(arr.variable_type === isTaxType)
            varList.push(arr);
        })
      }
      return {varList,globalVarList};
    } 

  export const setStepIndexUpdation = (stepsArr) => {
    
  } 